<template>
  <div
    class="h-full relative overflow-hidden flex flex-col justify-center items-center"
  >
    <span
      class="w-242 h-3.5 text-center bg-vivid-pink font-mulish-bold text-white text-2 tracking-wider mt-16 flex items-center justify-center"
      >5. Guild Management</span
    >
    <div class="mt-14 w-3/12">
      <img class="w-full" :src="`${imgPath}/SystemChanges/guildrework_5.png`" />
    </div>
    <p
      class="4xl:w-4/12 2xl:w-5/12 lg:w-6/12 font-mulish-medium text-very-pale-orange xl:text-1.8 lg:text-1.4 leading-2 tracking-wider mt-14 text-center"
    >
      You can set a guild slogan, prerequisites, and recruit new members through
      the 'Manage Guild' tab. Some functions have been moved to this menu from
      the Guild NPC.
    </p>
    <p
      class="font-mulish-medium text-strong-red xl:text-1.8 lg:text-1.4 leading-1.8 tracking-wider 2xl:mt-14 xl:mt-8 text-center"
    >
      ! This button is disabled for guild members who do not have the
      permissions.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style></style>
